const BankRecordMatchType = {
	MATCHED: 'MATCHED',
	UNMATCHED: 'UNMATCHED'
};

export default BankRecordMatchType;
